// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Xbtdr","colMin":"styles_colMin__1935j"};